import * as User from './user/';
export default { User: User };



//////////////////
// WEBPACK FOOTER
// ./src/app/users/index.ts
// module id = 1282
// module chunks = 0